import { observer } from 'mobx-react';
import { findLinkBy } from '../../../../../../../../Links';
import { FormTemplate } from '../../../../../../../../Resource/FormTemplates/Types';
import { T } from '../../../../../../../../Translations';
import { ShareUrlResource } from '../../../../../../Types';
import { LearningCollectionPublishResource } from '../Store/Types';
import InviteModalAndShareUrl from './InviteModalAndShareUrl';

export interface Props {
  shareUrlResource: ShareUrlResource;
  learningCollectionPublishResource: LearningCollectionPublishResource;
  template: FormTemplate;
}

function Share({ shareUrlResource, learningCollectionPublishResource, template }: Props) {
  return findLinkBy({ rel: 'shared-url-short-link', type: 'text/html' }, shareUrlResource.links)
    .map((link) => (
      <InviteModalAndShareUrl
        link={link}
        learningCollectionPublishResource={learningCollectionPublishResource}
        template={template}
      />
    ))
    .getOrElse(() => (
      <p className="mt-8 text-gray-600">
        <T kind="Your organization has no email domains..." />
      </p>
    ));
}

export default observer(Share);
